/**
 * Every model route (plan-010 MB-DM, design §24.3.1, §24.9; ADDED 2026-10-01), in the order
 * `model_usage.model_route`'s CHECK lists them (migration 0051).
 */
export const MODEL_ROUTE_KIND = ["gpu_pool", "model_backup"];
/** The backup codes as the migration of design §38.9 lists them (plan-027 DM-SMB; ADDED 2026-10-23). */
export const MODEL_BACKUP_CODE = ["first", "second"];
/**
 * The backup sequence (design §38.4, DD27-3): the first, then the second — the order routing and admission try them
 * in when no `gpu_pool` stands eligible. Fixed; no key reorders it (plan-027 OD-1).
 */
export const MODEL_BACKUP_SEQUENCE = Object.freeze(["first", "second"]);
//# sourceMappingURL=usage.js.map